import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Chevron from './Chevron';

const ChevronIcon = props => (
    <IconFromPath {...props} Path={Chevron} />
);

export default ChevronIcon;
